import { render, staticRenderFns } from "./CashierSessionNotActivePopupMessageForNewOrder.vue?vue&type=template&id=28e0ac63&"
import script from "./CashierSessionNotActivePopupMessageForNewOrder.vue?vue&type=script&lang=js&"
export * from "./CashierSessionNotActivePopupMessageForNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./CashierSessionNotActivePopupMessageForNewOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports